<template>
    <div class="divider">
        <hr class="line" />
        <span class="text">{{ word }}</span>
        <hr class="line" />
    </div>
</template>

<script>
  export default {
      name: 'Divider',
      props: {
          word: {
              type: String,
              default: 'ou'
          }
      }
  };
</script>

<style scoped>
    .divider {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;
    }

    .line {
        flex-grow: 1;
        border: none;
        border-top: 1px solid #B8C1CC;
    }

    .text {
        font-size: 16px;
        line-height: 16px;
        font-weight: 500;
        color: #2F363E;
        padding: 0 16px;
    }
</style>